import { api } from "api/api";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Usuario from "model/administracao/cadastro/Usuario";
import Produto from "model/administracao/cadastro/produto/Produto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Pedido from "model/producao/Pedido";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { generateKey } from "utils/generateKey";

class PedidoService implements BaseServiceCadastros<Pedido> {
    
    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/pedido/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Pedido>((resolve, reject): void => {
            api
                .get(`/pedido/consultar/${id}`)
                .then(response => {
                    const pedido: Pedido = response.data;
                    pedido.itens.forEach(item => {
                        item.key = generateKey();
                        return item;
                    });
                    resolve(pedido);
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(pedido: Pedido) {
        return new Promise<Pedido>((resolve, reject): void => {
            api
                .post(`/pedido/incluir`, JSON.stringify(pedido))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(pedido: Pedido) {
        console.log(pedido)
        return new Promise<Pedido>((resolve, reject): void => {
            api
                .put(`/pedido/editar`, JSON.stringify(pedido))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/pedido/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    fechar(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .put(`/pedido/fechar/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    reabrir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .put(`/pedido/reabrir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    clientes() {
        return new Promise<Pessoa[]>((resolve, reject): void => {
            api
                .get(`/pedido/clientes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    produtos() {
        return new Promise<Produto[]>((resolve, reject): void => {
            api
                .get(`/pedido/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getListaStatus() {
        return [
            { label: 'Aberto', value: 'ABERTO' },
            { label: 'Fechado', value: 'FECHADO' },
            { label: "Liquidado", value: "LIQUIDADO" },
            { label: 'Cancelado', value: 'CANCELADO' },
        ]
    }

    getStatus(status: string) {
        return this.getListaStatus().find(item => item.value === status)?.label || "";
    }

    getListaStatusItem() {
        return [
            { label: 'Aberto', value: 'ABERTO' },
            { label: 'Fechado', value: 'FECHADO' },
            { label: "Liquidado", value: "LIQUIDADO" },
            { label: 'Cancelado', value: 'CANCELADO' },
        ]

    }

    getStatusItem(status: string) {
        return this.getListaStatusItem().find(item => item.value === status)?.label || "";
    }

    getListaStatusItemFilter() {
        return [
            { label: 'Aberto', value: 'A' },
            { label: 'Fechado', value: 'F' },
            { label: "Liquidado", value: "L" },
            { label: 'Cancelado', value: 'C' },
        ]

    }

    getStatusPedidoFilter() {
        return [
            { label: 'Aberto', value: 'A' },
            { label: 'Fechado', value: 'F' },
            { label: 'Liquidado', value: 'L' },
            { label: 'Cancelada', value: 'C' }
        ]

    }


}

export default PedidoService;